import { Component, OnInit } from '@angular/core';

import { Location } from '@angular/common';

import { NotificationService } from 'src/app/Service/notification.service';

import { FormGroup, FormBuilder, FormControl, NgForm } from '@angular/forms';

import axios from 'src/app/Service/axios';

import { Observable, map, of, startWith } from 'rxjs';

import { animate, state, style, transition, trigger } from '@angular/animations';

import { Router } from '@angular/router';

import Chart from 'chart.js/auto';

import zoomPlugin from 'chartjs-plugin-zoom';

import VectorSource from "ol/source/Vector";

import VectorLayer from "ol/layer/Vector";

import { Circle, Fill, Icon, Stroke, Style, Text } from "ol/style";

import { MapService } from "src/app/Service/map.service";

import Map from 'ol/Map';

import View from 'ol/View';

import * as olProj from 'ol/proj';

import {

  DragRotateAndZoom,

  defaults as defaultInteractions,

} from 'ol/interaction';


import Feature from 'ol/Feature';

import { Tile as TileLayer } from 'ol/layer';

import OSM from 'ol/source/OSM';

import { Point } from "ol/geom";

import { BingMaps, Cluster, Vector, XYZ } from "ol/source";

import AnimatedCluster from "ol-ext/layer/AnimatedCluster";

import SelectCluster from "ol-ext/interaction/SelectCluster";

import { Tile } from "ol/layer";
import { GurdServiceService } from 'src/app/Service/gurd-service.service';


declare let $: any;

@Component({

  selector: 'app-office-dashboard',

  templateUrl: './office-dashboard.component.html',

  styleUrls: ['./office-dashboard.component.css']

})

export class OfficeDashboardComponent implements OnInit {

  chart1: any;

  chart2: any;

  chart3: any;

  chart4: any;

  chart4_1: any;

  chart5: any;

  chart6: any;

  chart7: any;

  mapData1: any;

  mapData2: any;

  list_Domain: any = [];

  searchModel: FormGroup = this.FormBuilder.group({

    iSystemUser: new FormControl(this.gurdService.decrypt(localStorage.getItem('ID')!)),

    strSession: new FormControl(this.gurdService.decrypt(localStorage.getItem('Session')!)),

    iMobileDomain: new FormControl('-1')

  })

  CHART_COLORS3: any = {

    green: 'rgb(111, 255, 111)',

    purple: 'rgb(255, 153, 204)',

    blue: 'rgb(29, 179, 214)',

    orange: 'rgb(45, 103, 103)',

    yellow: 'rgb(251, 101, 150)',

    red: 'rgb(36, 123, 46)',

    grey: 'rgb(103, 13, 183)',

  };

  source: any;

  vector: any;

  layers: any = [];

  source2: any;

  vector2: any;

  layers2: any = [];

  private bOfflineMap: boolean = (<any>window).bOfflineMap;

  private strMapUrl: string = (<any>window).strMapUrl;

  constructor(

    private location: Location,

    private Notification: NotificationService,

    private FormBuilder: FormBuilder,

    private router: Router,

    private mapService: MapService,

    private gurdService: GurdServiceService

  ) {

    Chart.register(zoomPlugin);

  }

  ngOnInit(): void {

    this.getDomain();

    this.getAllCharts();

  }

  async getDomain() {

    const resp = await axios.post(`GetMobileDomain4Report?iSystemUser=${this.gurdService.decrypt(localStorage.getItem("ID")!)}`, {});

    let res = JSON.parse(resp.data);

    this.list_Domain = res;

  }

  async getAllCharts() {

    this.get_Chart1();

    this.get_Chart2();

    this.get_Chart3();

    this.get_Chart4();

    this.get_Chart4_1();

    this.get_Chart5();

    this.get_Chart6();

    this.get_Chart7();

    this.get_Map1();

    this.get_Map2();

  }

  async get_Chart1() {

    let res = JSON.parse(((await axios.post(`Report_MobileCountBaseMobileDomain`, this.searchModel.value)).data.toString()));

    if (res.iResult == 0) return this.Notification.showError(res.strError)

    let label: Array<any> = [];

    let dataChart: Array<any> = [];

    res.forEach((element: any) => {

      label.push(element.X);

      dataChart.push(element.Y);

    });

    var canvas = document.getElementById("myChart1") as any;

    if (this.chart1) this.chart1.destroy();

    var ctx = canvas.getContext("2d");

    this.chart1 = new Chart(ctx, {

      type: 'bar',

      data: {

        labels: label,

        datasets: [

          {
            label: '',

            data: dataChart,

            backgroundColor: Object.values(this.CHART_COLORS3),


          },

        ],

      },

      options: {
                responsive: true,
        interaction: {
          mode: 'nearest',
          intersect: false
        },
        plugins: {
          zoom: {
            zoom: {
              wheel: {
                enabled: true,
              },
              pinch: {
                enabled: true
              },
              mode: 'x',
            }
          },
          legend: {
            position: 'center',
          },
          title: {
            display: false,
          },
        },
        scales: {
          x: {
            ticks: {
              color: 'black',
              font: {
                family: "vazir",
                size: 12
              }
            }
          }
        }
      },
    });


  }

  async get_Chart2() {

    let res = JSON.parse(((await axios.post(`Peysepar_Dashboard_TribCountBaseMobileDomain`, this.searchModel.value)).data.toString()));

    if (res.iResult == 0) return this.Notification.showError(res.strError)

    let label: Array<any> = [];

    let dataChart: Array<any> = [];

    res.forEach((element: any) => {

      label.push(element.X);

      dataChart.push(element.Y);

    });

    var canvas = document.getElementById("myChart2") as any;

    if (this.chart2) this.chart2.destroy();

    var ctx = canvas.getContext("2d");

    this.chart2 = new Chart(ctx, {

      type: 'bar',

      data: {

        labels: label,

        datasets: [

          {
            label: '',

            data: dataChart,

            backgroundColor: Object.values(this.CHART_COLORS3),


          },

        ],

      },

      options: {
                responsive: true,
        interaction: {
          mode: 'nearest',
          intersect: false
        },
        plugins: {
          zoom: {
            zoom: {
              wheel: {
                enabled: true,
              },
              pinch: {
                enabled: true
              },
              mode: 'x',
            }
          },
          legend: {
            position: 'center',
          },
          title: {
            display: false,
          },
        },
        scales: {
          x: {
            ticks: {
              color: 'black',
              font: {
                family: "vazir",
                size: 12
              }
            }
          }
        }
      },
    });


  }

  async get_Chart3() {

    let res = JSON.parse(((await axios.post(`Peysepar_Dashboard_TribCountBaseChart`, this.searchModel.value)).data.toString()));

    if (res.iResult == 0) return this.Notification.showError(res.strError)

    let label: Array<any> = [];

    let dataChart: Array<any> = [];

    res.forEach((element: any) => {

      label.push(element.X);

      dataChart.push(element.Y);

    });

    var canvas = document.getElementById("myChart3") as any;

    if (this.chart3) this.chart3.destroy();

    var ctx = canvas.getContext("2d");

    this.chart3 = new Chart(ctx, {

      type: 'bar',

      data: {

        labels: label,

        datasets: [

          {
            label: '',

            data: dataChart,

            backgroundColor: Object.values(this.CHART_COLORS3),


          },

        ],

      },

      options: {
                responsive: true,
        interaction: {
          mode: 'nearest',
          intersect: false
        },
        plugins: {
          zoom: {
            zoom: {
              wheel: {
                enabled: true,
              },
              pinch: {
                enabled: true
              },
              mode: 'x',
            }
          },
          legend: {
            position: 'center',
          },
          title: {
            display: false,
          },
        },
        scales: {
          x: {
            ticks: {
              color: 'black',
              font: {
                family: "vazir",
                size: 12
              }
            }
          }
        }
      },
    });


  }

  async get_Chart4() {

    let res = JSON.parse(((await axios.post(`Peysepar_Dashboard_TribCountBaseMobile`, this.searchModel.value)).data.toString()));

    if (res.iResult == 0) return this.Notification.showError(res.strError)

    let label: Array<any> = [];

    let dataChart: Array<any> = [];

    res.forEach((element: any) => {

      label.push(element.X);

      dataChart.push(element.Y);

    });

    var canvas = document.getElementById("myChart4") as any;

    if (this.chart4) this.chart4.destroy();

    var ctx = canvas.getContext("2d");

    this.chart4 = new Chart(ctx, {

      type: 'bar',

      data: {

        labels: label,

        datasets: [

          {
            label: '',

            data: dataChart,

            backgroundColor: Object.values(this.CHART_COLORS3),


          },

        ],

      },

      options: {
                responsive: true,
        interaction: {
          mode: 'nearest',
          intersect: false
        },
        plugins: {
          zoom: {
            zoom: {
              wheel: {
                enabled: true,
              },
              pinch: {
                enabled: true
              },
              mode: 'x',
            }
          },
          legend: {
            position: 'center',
          },
          title: {
            display: false,
          },
        },
        scales: {
          x: {
            ticks: {
              color: 'black',
              font: {
                family: "vazir",
                size: 12
              }
            }
          }
        }
      },
    });


  }

  async get_Chart4_1() {

    let res = JSON.parse(((await axios.post(`Peysepar_Dashboard_TribCountBaseMobileType`, this.searchModel.value)).data.toString()));

    if (res.iResult == 0) return this.Notification.showError(res.strError)

    let label: Array<any> = [];

    let dataChart: Array<any> = [];

    res.forEach((element: any) => {

      label.push(element.X == null ? 'نامشخص' : element.X);

      dataChart.push(element.Y);

    });

    var canvas = document.getElementById("myChart4_1") as any;

    if (this.chart4_1) this.chart4_1.destroy();

    var ctx = canvas.getContext("2d");

    this.chart4_1 = new Chart(ctx, {

      type: 'bar',

      data: {

        labels: label,

        datasets: [

          {
            label: '',

            data: dataChart,

            backgroundColor: Object.values(this.CHART_COLORS3),


          },

        ],

      },

      options: {
                responsive: true,
        interaction: {
          mode: 'nearest',
          intersect: false
        },
        plugins: {
          zoom: {
            zoom: {
              wheel: {
                enabled: true,
              },
              pinch: {
                enabled: true
              },
              mode: 'x',
            }
          },
          legend: {
            position: 'center',
          },
          title: {
            display: false,
          },
        },
        scales: {
          x: {
            ticks: {
              color: 'black',
              font: {
                family: "vazir",
                size: 12
              }
            }
          }
        }
      },
    });


  }

  async get_Chart5() {

    let res = JSON.parse(((await axios.post(`Peysepar_Dashboard_TribCountBasePassenger`, this.searchModel.value)).data.toString()));

    if (res.iResult == 0) return this.Notification.showError(res.strError)

    let label: Array<any> = [];

    let dataChart: Array<any> = [];

    res.forEach((element: any) => {

      label.push(element.X);

      dataChart.push(element.Y);

    });

    var canvas = document.getElementById("myChart5") as any;

    if (this.chart5) this.chart5.destroy();

    var ctx = canvas.getContext("2d");

    this.chart5 = new Chart(ctx, {

      type: 'bar',

      data: {

        labels: label,

        datasets: [

          {
            label: '',

            data: dataChart,

            backgroundColor: Object.values(this.CHART_COLORS3),


          },

        ],

      },

      options: {
                responsive: true,
        interaction: {
          mode: 'nearest',
          intersect: false
        },
        plugins: {
          zoom: {
            zoom: {
              wheel: {
                enabled: true,
              },
              pinch: {
                enabled: true
              },
              mode: 'x',
            }
          },
          legend: {
            position: 'center',
          },
          title: {
            display: false,
          },
        },
        scales: {
          x: {
            ticks: {
              color: 'black',
              font: {
                family: "vazir",
                size: 12
              }
            }
          }
        }
      },
    });


  }

  async get_Chart6() {

    let res = JSON.parse(((await axios.post(`Peysepar_Dashboard_TribCountBaseDays`, this.searchModel.value)).data.toString()));

    if (res.iResult == 0) return this.Notification.showError(res.strError)

    let label: Array<any> = [];

    let dataChart: Array<any> = [];

    res.forEach((element: any) => {

      label.push(element.X);

      dataChart.push(element.Y);

    });

    var canvas = document.getElementById("myChart6") as any;

    if (this.chart6) this.chart6.destroy();

    var ctx = canvas.getContext("2d");

    this.chart6 = new Chart(ctx, {

      type: 'bar',

      data: {

        labels: label,

        datasets: [

          {
            label: '',

            data: dataChart,

            backgroundColor: Object.values(this.CHART_COLORS3),


          },

        ],

      },

      options: {
                responsive: true,
        interaction: {
          mode: 'nearest',
          intersect: false
        },
        plugins: {
          zoom: {
            zoom: {
              wheel: {
                enabled: true,
              },
              pinch: {
                enabled: true
              },
              mode: 'x',
            }
          },
          legend: {
            position: 'center',
          },
          title: {
            display: false,
          },
        },
        scales: {
          x: {
            ticks: {
              color: 'black',
              font: {
                family: "vazir",
                size: 12
              }
            }
          }
        }
      },
    });


  }

  async get_Chart7() {

    let res = JSON.parse(((await axios.post(`Peysepar_Dashboard_TribCountBaseHours`, this.searchModel.value)).data.toString()));

    if (res.iResult == 0) return this.Notification.showError(res.strError)

    let label: Array<any> = [];

    let dataChart: Array<any> = [];

    res.forEach((element: any) => {

      label.push(element.X);

      dataChart.push(element.Y);

    });

    var canvas = document.getElementById("myChart7") as any;

    if (this.chart7) this.chart7.destroy();

    var ctx = canvas.getContext("2d");

    this.chart7 = new Chart(ctx, {

      type: 'bar',

      data: {

        labels: label,

        datasets: [

          {
            label: '',

            data: dataChart,

            backgroundColor: Object.values(this.CHART_COLORS3),


          },

        ],

      },

      options: {
                responsive: true,
        interaction: {
          mode: 'nearest',
          intersect: false
        },
        plugins: {
          zoom: {
            zoom: {
              wheel: {
                enabled: true,
              },
              pinch: {
                enabled: true
              },
              mode: 'x',
            }
          },
          legend: {
            position: 'center',
          },
          title: {
            display: false,
          },
        },
        scales: {
          x: {
            ticks: {
              color: 'black',
              font: {
                family: "vazir",
                size: 12
              }
            }
          }
        }
      },
    });


  }

  async get_Map1() {

    let res = JSON.parse(((await axios.post(`Peysepar_Dashboard_Map_Source`, this.searchModel.value)).data.toString()));

    if (res.iResult == 0) return this.Notification.showError(res.strError);

    setTimeout(() => {

      if (this.mapData1) this.mapData1.setTarget(null);

      this.source = new VectorSource({ wrapX: false });

      this.vector = new VectorLayer({

        source: this.source,

      });

      if (this.bOfflineMap) {

        this.layers.push(

          new TileLayer({

            source: new XYZ({

              url: this.strMapUrl,

              attributions: 'Map data © RayanAndishehNasr' // 

            }),

          })

        );
      }

      else {

        const styles = [

          'AerialWithLabelsOnDemand',

        ];

        let i, ii;

        for (i = 0, ii = styles.length; i < ii; ++i) {
          this.layers.push(
            new TileLayer({
              visible: false,
              preload: Infinity,
              source: new BingMaps({
                key: 'Ap0AObt84NcDaUThCeWOj52ZqUHv6k4TJhjLibR-DghC-semgoj-0uPbIi8r0E4j',

                imagerySet: styles[i],
              }),

            }),
          );
        }

        this.layers.push(new TileLayer({ source: new OSM({}) }), this.vector)
      }

      this.mapData1 = new Map({

        target: "map1",

        view: new View({

          zoom: 4,

          center: olProj.fromLonLat([51.3833554, 35.6770113])

        }),

        layers: this.layers

      });

      this.clustersLayer(res, this.searchModel.value);

    }, 500);

  }

  async get_Map2() {

    let res = JSON.parse(((await axios.post(`Peysepar_Dashboard_Map_Destination`, this.searchModel.value)).data.toString()));

    if (res.iResult == 0) return this.Notification.showError(res.strError);

    setTimeout(() => {

      if (this.mapData2) this.mapData2.setTarget(null);

      this.source2 = new VectorSource({ wrapX: false });

      this.vector = new VectorLayer({

        source: this.source2,

      });

      if (this.bOfflineMap) {

        this.layers2.push(

          new TileLayer({

            source: new XYZ({

              url: this.strMapUrl,

              attributions: 'Map data © RayanAndishehNasr' // 

            }),

          })

        );
      }

      else {

        const styles = [

          'AerialWithLabelsOnDemand',

        ];

        let i, ii;

        for (i = 0, ii = styles.length; i < ii; ++i) {
          this.layers2.push(
            new TileLayer({
              visible: false,
              preload: Infinity,
              source: new BingMaps({
                key: 'Ap0AObt84NcDaUThCeWOj52ZqUHv6k4TJhjLibR-DghC-semgoj-0uPbIi8r0E4j',

                imagerySet: styles[i],
              }),

            }),
          );
        }

        this.layers2.push(new TileLayer({ source: new OSM({}) }), this.vector2)
      }

      this.mapData2 = new Map({

        target: "map2",

        view: new View({

          zoom: 4,

          center: olProj.fromLonLat([51.3833554, 35.6770113])

        }),

        layers: this.layers2

      });

      this.clustersLayer2(res, this.searchModel.value);

    }, 500);

  }

  async clustersLayer(data: any, model: []) {

    setTimeout(() => {

      this.mapData1.on('click', (e: any) => {

        if (e.dragging) return

        var el = this.mapService.mapPointerMove(

          this.mapData1.getEventPixel(e.originalEvent),

          this.mapData1
        );

        // if (el.featureLayer && el.featureLayer.feature.values_.features.length == 1) this.showDetail(el.featureLayer.feature.values_.features[0].values_.data.strMobile, model)

        $("#link").click(() => {

          var tooltip = $('#map_tooltip');

          tooltip.tooltip('hide');

        });

      });

      this.mapData1.getView().on('propertychange', function (e: any) {

        var tooltip = $('#map_tooltip');

        tooltip.tooltip('hide');

      });

    }, 200);

    // Cluster Source

    var clusterSource = new Cluster({

      distance: 40,

      source: new Vector()

    }) as any;


    let addFeatures = (nb: any) => {

      var ext = this.mapData1.getView().calculateExtent(this.mapData1.getSize());

      var features = [];

      for (var i = 0; i < data.length; ++i) {

        features[i] = new Feature({

          type: 'removable',

          geometry: new Point(this.mapService.transformCoordinates2([

            data[i].fLon,

            data[i].fLat])


          ),

          id_: data[i]?.strUnitId,

          data: {

            // strMobile: data[i].strMobile,

            // strMobileDomain_strComment: data[i].strMobileDomain_strComment,

            // strPassenger_FullName: data[i].strPassenger_FullName,

          },

        });

        features[i].set("id", i);
      }
      clusterSource.getSource().clear();

      clusterSource.getSource().addFeatures(features);


    }

    // Style for the clusters
    var styleCache = {} as any;
    function getStyle(feature: any, resolution: any) {
      var size = feature.get("features").length;
      var style = styleCache[size];
      if (!style) {
        var color = size > 25 ? "192,0,0" : size > 8 ? "255,128,0" : "0,128,0";
        var radius = Math.max(8, Math.min(size * 0.75, 20));
        var dash = (2 * Math.PI * radius) / 6;
        var dashs = [0, dash, dash, dash, dash, dash, dash];
        style = styleCache[size] = new Style({
          image: new Circle({
            radius: radius,
            stroke: new Stroke({
              color: "rgba(" + color + ",0.5)",
              width: 15,
              lineDash: dashs,
              lineCap: "butt"
            }),
            fill: new Fill({
              color: "rgba(" + color + ",1)"
            })
          }),
          text: new Text({
            text: size.toString(),
            fill: new Fill({
              color: "#fff"
            })
          })
        });
      }
      return style;
    }

    // Animated cluster layer
    var clusterLayer = new AnimatedCluster({
      //name: "Cluster",
      source: clusterSource,
      animationDuration: 700,
      // Cluster style
      style: getStyle
    });
    this.mapData1.addLayer(clusterLayer);
    // add 2000 features
    addFeatures(2000);

    var style1 = new Style({
      image: new Circle({
        radius: 5,
        stroke: new Stroke({
          color: "rgba(128,0,0,0.8)",
          width: 2
        }),
        fill: new Fill({
          color: "rgba(128,0,0,0.8)"
        })
      }),
      // Draw a link beetween points (or not)
      stroke: new Stroke({
        color: "#fff",
        width: 1
      })
    });
    // Select interaction to spread cluster out and select features
    var selectCluster = new SelectCluster({
      // Point radius: to calculate distance between the features
      pointRadius: 7,
      animate: true,
      // Feature style when it springs apart
      featureStyle: function () {
        return [style1];
      },
      // selectCluster: false,	// disable cluster selection
      // Style to draw cluster when selected
      style: function (f, res) {
        var cluster = f.get("features");
        if (cluster.length > 1) {
          return getStyle(f, res);
        } else {
          return [
            new Style({
              image: new Circle({
                stroke: new Stroke({
                  color: "rgba(0,0,192,0.5)",
                  width: 2
                }),
                fill: new Fill({ color: "rgba(0,0,192,0.3)" }),
                radius: 5
              })
            })
          ];
        }
      }
    });
    this.mapData1.addInteraction(selectCluster);


  }

  async clustersLayer2(data: any, model: []) {

    setTimeout(() => {

      this.mapData2.on('click', (e: any) => {

        if (e.dragging) return

        var el = this.mapService.mapPointerMove(

          this.mapData2.getEventPixel(e.originalEvent),

          this.mapData2
        );

        // if (el.featureLayer && el.featureLayer.feature.values_.features.length == 1) this.showDetail(el.featureLayer.feature.values_.features[0].values_.data.strMobile, model)

        $("#link").click(() => {

          var tooltip = $('#map_tooltip');

          tooltip.tooltip('hide');

        });

      });

      this.mapData2.getView().on('propertychange', function (e: any) {

        var tooltip = $('#map_tooltip');

        tooltip.tooltip('hide');

      });

    }, 200);

    // Cluster Source

    var clusterSource = new Cluster({

      distance: 40,

      source: new Vector()

    }) as any;


    let addFeatures = (nb: any) => {

      var ext = this.mapData2.getView().calculateExtent(this.mapData2.getSize());

      var features = [];

      for (var i = 0; i < data.length; ++i) {

        features[i] = new Feature({

          type: 'removable',

          geometry: new Point(this.mapService.transformCoordinates2([

            data[i].fLon,

            data[i].fLat])


          ),

          id_: data[i]?.strUnitId,

          data: {

            // strMobile: data[i].strMobile,

            // strMobileDomain_strComment: data[i].strMobileDomain_strComment,

            // strPassenger_FullName: data[i].strPassenger_FullName,

          },

        });

        features[i].set("id", i);
      }
      clusterSource.getSource().clear();

      clusterSource.getSource().addFeatures(features);


    }

    // Style for the clusters
    var styleCache = {} as any;
    function getStyle(feature: any, resolution: any) {
      var size = feature.get("features").length;
      var style = styleCache[size];
      if (!style) {
        var color = size > 25 ? "192,0,0" : size > 8 ? "255,128,0" : "0,128,0";
        var radius = Math.max(8, Math.min(size * 0.75, 20));
        var dash = (2 * Math.PI * radius) / 6;
        var dashs = [0, dash, dash, dash, dash, dash, dash];
        style = styleCache[size] = new Style({
          image: new Circle({
            radius: radius,
            stroke: new Stroke({
              color: "rgba(" + color + ",0.5)",
              width: 15,
              lineDash: dashs,
              lineCap: "butt"
            }),
            fill: new Fill({
              color: "rgba(" + color + ",1)"
            })
          }),
          text: new Text({
            text: size.toString(),
            fill: new Fill({
              color: "#fff"
            })
          })
        });
      }
      return style;
    }

    // Animated cluster layer
    var clusterLayer = new AnimatedCluster({
      //name: "Cluster",
      source: clusterSource,
      animationDuration: 700,
      // Cluster style
      style: getStyle
    });
    this.mapData2.addLayer(clusterLayer);
    // add 2000 features
    addFeatures(2000);

    var style1 = new Style({
      image: new Circle({
        radius: 5,
        stroke: new Stroke({
          color: "rgba(128,0,0,0.8)",
          width: 2
        }),
        fill: new Fill({
          color: "rgba(128,0,0,0.8)"
        })
      }),
      // Draw a link beetween points (or not)
      stroke: new Stroke({
        color: "#fff",
        width: 1
      })
    });
    // Select interaction to spread cluster out and select features
    var selectCluster = new SelectCluster({
      // Point radius: to calculate distance between the features
      pointRadius: 7,
      animate: true,
      // Feature style when it springs apart
      featureStyle: function () {
        return [style1];
      },
      // selectCluster: false,	// disable cluster selection
      // Style to draw cluster when selected
      style: function (f, res) {
        var cluster = f.get("features");
        if (cluster.length > 1) {
          return getStyle(f, res);
        } else {
          return [
            new Style({
              image: new Circle({
                stroke: new Stroke({
                  color: "rgba(0,0,192,0.5)",
                  width: 2
                }),
                fill: new Fill({ color: "rgba(0,0,192,0.3)" }),
                radius: 5
              })
            })
          ];
        }
      }
    });
    this.mapData2.addInteraction(selectCluster);


  }

  goBack() {

    this.router.navigate(['/'])

  }

}
